<template>
    <div class="motivationProgram">
        <div class="groupField_wrap sp-b">
            <div class="flex_center">
                <field
                    margin="0 10px 0 0"
                    width="410px"
                    label="Customer"
                    placeholder="Select customer"
                    @updateAutocomplete="onAutocomplete($event, 'customer_id')"
                    :autocompleteValue="customer_id"
                    :items="customers"
                    :isClearable="false"
                    is-autocomplete
                    is-disabled
                ></field>
                <field
                    margin="0 10px 0 0"
                    width="200px"
                    label="Unit type"
                    placeholder="Select unit type"
                    @updateSelect="onAutocomplete($event, 'unit_type_id')"
                    :autocompleteValue="unit_type_id"
                    :items="workOrderType"
                    :isClearable="false"
                    is-select
                    is-disabled
                ></field>
                <field
                    margin="0 10px 0 0"
                    width="200px"
                    type="text"
                    label="Start date"
                    placeholder="Enter date"
                    :dateValue="date"
                    @updateDate="onDate($event, 'date')"
                    :dateAllowed="{ onlyMonday: true, isSameOrBefore: true }"
                    is-no-title
                    is-date
                ></field>
            </div>
            <div class="flex_center">
                <field
                    margin="0 10px 0 0"
                    width="150px"
                    type="number"
                    label="Plan rate lvl 1"
                    placeholder="0"
                    :setInputValue="rate_1"
                    icon="percent"
                    @updateInput="onInput($event, 'rate_1')"
                ></field>
                <field
                    margin="0 10px 0 0"
                    width="150px"
                    type="number"
                    label="Plan rate lvl 2"
                    placeholder="0"
                    :setInputValue="rate_2"
                    icon="percent"
                    @updateInput="onInput($event, 'rate_2')"
                ></field>
                <field
                    margin="0 10px 0 0"
                    width="150px"
                    type="number"
                    label="Plan rate lvl 3"
                    placeholder="0"
                    :setInputValue="rate_3"
                    icon="percent"
                    @updateInput="onInput($event, 'rate_3')"
                ></field>
            </div>
        </div>
        <div class="groupField_wrap sp-b">
            <div class="flex_center">
                <div class="flex_center">
                    <div class="groupTitle">Total</div>
                    <field
                        margin="0 10px 0 0"
                        width="200px"
                        label="Status"
                        placeholder="Select status"
                        @updateMultiSelect="onAutocomplete($event, 'filter_total_status')"
                        :multiValue="filter_total_status"
                        :items="statusList"
                        is-multiple
                        is-btn-all
                        is-attach
                    ></field>
                    <field
                        margin="0 10px 0 0"
                        width="200px"
                        label="Company owned"
                        placeholder="Select status"
                        @updateMultiSelect="onAutocomplete($event, 'filter_total_company_owned')"
                        :multiValue="filter_total_company_owned"
                        :items="companyOwnedList"
                        is-multiple
                        is-btn-all
                        is-attach
                    ></field>
                </div>
                <div class="flex_center">
                    <div class="groupTitle">Motivation</div>
                    <field
                        margin="0 10px 0 0"
                        width="200px"
                        label="Status"
                        placeholder="Select status"
                        @updateMultiSelect="onAutocomplete($event, 'filter_motivation_status')"
                        :multiValue="filter_motivation_status"
                        :items="statusList"
                        is-multiple
                        is-btn-all
                        is-attach
                    ></field>
                    <field
                        margin="0 10px 0 0"
                        width="200px"
                        label="Company owned"
                        placeholder="Select status"
                        @updateMultiSelect="onAutocomplete($event, 'filter_motivation_company_owned')"
                        :multiValue="filter_motivation_company_owned"
                        :items="companyOwnedList"
                        is-multiple
                        is-btn-all
                        is-attach
                    ></field>
                </div>
            </div>

            <div class="motivationProgram_apply">
                <button @click="onApply" class="motivationProgram_apply-btn">Apply</button>
            </div>
        </div>
        <statistics-chart
            v-if="statistics && statistics.length"
            :statistics="statistics"
            custom-css="motivation"
            @updateStatisticsData="onMotivationProgramData"
        ></statistics-chart>
        <div class="chartWrapper groupField_wrap">
            <line-chart
                v-if="chartData"
                :chartData="chartData"
                :chartOptions="getChartOptions"
            ></line-chart>
        </div>
        <motivation-info
            v-if="isStatisticsInfo"
            :currentDataInfo="currentDataInfo"
            @updateClose="isStatisticsInfo = false"
        ></motivation-info>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import MotivationInfo from "@/components/Fleet/WorkOrdersStatistics/MotivationProgram/MotivationInfo/MotivationInfo";
import StatisticsChart from "@/components/Fleet/WorkOrdersStatistics/StatisticsChart/StatisticsChart";
import LineChart from "@/components/Fleet/WorkOrdersStatistics/LineChart/LineChart";
// helper
import { positiveNumber, splitArray } from "@/helper";
// constants
import { chartConfig, chartOptions } from "@/components/Fleet/WorkOrdersStatistics/LineChart/chartLineConfig";

export default {
	name: "MotivationProgram",
	components: {
		LineChart,
		StatisticsChart,
		MotivationInfo
	},
	computed: {
		...mapGetters([ 'motivationProgramData' ]),
		getChartOptions() {
			return chartOptions;
		}
	},
	data: () => ({
		chartData: null,
		customers: [],
		statistics: [],
		filter_motivation_company_owned: [],
		filter_motivation_status: [],
		filter_total_company_owned: [],
		filter_total_status: [],
		workOrderUnitType: null,
		workOrderType: [],
		companyOwnedList: [ { id: 1, value: 'True' }, { id: 0, value: 'False' } ],
		statusList: [],
		customer_id: 328,
		unit_type_id: 1,
		type: 2,
		date: null,
		rate_1: 0,
		rate_2: 0,
		rate_3: 0,
		isStatisticsInfo: false,
		currentDataInfo: null
	}),
	methods: {
		...mapActions([ 'onMotivationProgram', 'onMotivationProgramEdit', 'onMotivationProgramInfo' ]),
		onAutocomplete({ value }, key) {
			this[key] = value;
		},
		onDate(value, key) {
			this[key] = value;
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		async onMotivationProgramData(date) {
			const {
				customer_id,
				unit_type_id,
				filter_motivation_company_owned,
				filter_total_company_owned,
				filter_motivation_status,
				filter_total_status
			} = this.$data;

			const values = {
				filter_customer_id: customer_id,
				filter_type: unit_type_id,
				filter_motivation_company_owned: this.formattedArray(filter_motivation_company_owned),
				filter_motivation_status: this.formattedArray(filter_motivation_status),
				filter_total_company_owned: this.formattedArray(filter_total_company_owned),
				filter_total_status: this.formattedArray(filter_total_status)
			};
			await this.onMotivationProgramInfo({ date, values });
			this.currentDataInfo = {
				currentDate: date,
				...values
			};
			this.isStatisticsInfo = true;
		},
		onSetMotivationProgramData(values) {
			if (values) {
				const {
					customers,
					date,
					workOrderUnitType,
					workOrderType,
					plan_rate,
					statistics,
					status
				} = values;

				this.chartData = chartConfig(statistics);

				this.customers = customers;
				this.statusList = status;
				this.statistics = splitArray(statistics, 7);
				this.date = date;
				this.workOrderUnitType = workOrderUnitType;
				this.workOrderType = workOrderType;
				for (const planRateKey in plan_rate) {
					this['rate_' + planRateKey] = plan_rate[planRateKey];
				}
			}
		},
		formattedArray(array) {
			return array.map(item => item.id);
		},
		async onApply() {
			const {
				customer_id,
				unit_type_id,
				type,
				date,
				rate_1,
				rate_2,
				rate_3,
				filter_motivation_company_owned,
				filter_motivation_status,
				filter_total_company_owned,
				filter_total_status,
			} = this.$data;

			const values = {
				filter_customer_id: customer_id,
				filter_date: date,
				filter_orderType: type,
				filter_type: unit_type_id,
				rate_1: positiveNumber(rate_1),
				rate_2: positiveNumber(rate_2),
				rate_3: positiveNumber(rate_3),
				filter_motivation_company_owned: this.formattedArray(filter_motivation_company_owned),
				filter_motivation_status: this.formattedArray(filter_motivation_status),
				filter_total_company_owned: this.formattedArray(filter_total_company_owned),
				filter_total_status: this.formattedArray(filter_total_status)
			};

			await this.onMotivationProgramEdit(values);
			this.onSetMotivationProgramData(this.motivationProgramData);
		}
	},
	async mounted() {
		await this.onMotivationProgram();
		this.onSetMotivationProgramData(this.motivationProgramData);
	}
};
</script>

<style scoped lang="scss">
    @import "motivationProgram";
</style>
